import React from 'react'

import Button from 'components/Form/Button'
import { StateDescription, StateRoot, StateTitle } from './styled'

export default function NotificationState({ actionLabel, description, onAction, title }) {
    return (
        <StateRoot role="status">
            <StateTitle>{title}</StateTitle>
            {description ? <StateDescription>{description}</StateDescription> : null}
            {onAction ? (
                <Button color="blue" nospace outline width="fit-content" onClick={onAction}>{actionLabel}</Button>
            ) : null}
        </StateRoot>
    )
}
